import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { feedCollection } from "#root/schema/platform/newsrpm-parser";
import PageLayout from "./layout";

const title = (
  <Fragment>
    Incoming Feeds{" "}
    <Link className="button" to="/admin/platform/newsrpm-parser/feed/new">
      New Feed
    </Link>
  </Fragment>
);

export default function FeedsPage(): ReactNode {
  return (
    <PageLayout title="NewsRPM Parser - Feeds">
      <PaginatedList title={title} collection={feedCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Code</th>
              <th>Provider</th>
              <th>URL</th>
              <th>Last Successful Retrieval</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ id, providerCode, provider, uri, lastSuccessfulRetrieval, lastError }) => (
              <Fragment key={id}>
                <tr className={lastError ? "error" : ""}>
                  <td>{providerCode}</td>
                  <td>{provider}</td>
                  <td>{uri?.slice(0, 60)}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{lastSuccessfulRetrieval ? new Date(lastSuccessfulRetrieval).toLocaleString() : "N/A"}</td>
                  <td>
                    <Link to={`/admin/platform/newsrpm-parser/feed/${id}`}>View</Link>
                    &nbsp;&middot;&nbsp;<Link to={`/admin/platform/newsrpm-parser/feed/${id}/edit`}>Edit</Link>
                  </td>
                </tr>
                {lastError ? (
                  <tr className={lastError ? "extra" : ""}>
                    <td colSpan={5}>
                      <b>Error: {lastError.slice(0, 100)}</b>
                    </td>
                  </tr>
                ) : null}
              </Fragment>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
